// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"a4768a4a","168":"ef3ee3ec","637":"eb1cd1c1","834":"7dc668da"}[chunkId] + ".chunk.js";
};